import managerTypes from './manager.types';

export default {
  [managerTypes.UPLOAD_SUPPORTERS_SUCCESS](state, payload) {
    state.type = managerTypes.UPLOAD_SUPPORTERS_SUCCESS;
    state.data = { ...state.data, ...payload.data };
  },
  [managerTypes.UPLOAD_SUPPORTERS_FAILED](state, payload) {
    state.type = managerTypes.UPLOAD_SUPPORTERS_FAILED;
    state.error = payload.error;
  },
  [managerTypes.UPLOAD_SUPPORTERS_REQUEST](state) {
    state.type = managerTypes.UPLOAD_SUPPORTERS_REQUEST;
    state.error = '';
  },

  [managerTypes.FETCH_manager_SUCCESS](state, payload) {
    state.type = managerTypes.FETCH_manager_SUCCESS;
    state.data = payload.data;
  },
  [managerTypes.FETCH_manager_FAILED](state, payload) {
    state.type = managerTypes.FETCH_manager_FAILED;
    state.error = payload.error;
  },
  [managerTypes.FETCH_manager_REQUEST](state) {
    state.type = managerTypes.FETCH_manager_REQUEST;
    state.error = '';
  },

  [managerTypes.FETCH_WELCOME_SUCCESS](state, payload) {
    state.type = managerTypes.FETCH_WELCOME_SUCCESS;
    state.welcome = payload.data;
  },
  [managerTypes.FETCH_WELCOME_FAILED](state, payload) {
    state.type = managerTypes.FETCH_WELCOME_FAILED;
    state.error = payload.error;
  },
  [managerTypes.FETCH_WELCOME_REQUEST](state) {
    state.type = managerTypes.FETCH_WELCOME_REQUEST;
    state.error = '';
  },


  [managerTypes.DELETE_EMPLOYEES_SUCCESS](state) {
    state.type = managerTypes.DELETE_EMPLOYEES_SUCCESS;
  },
  [managerTypes.DELETE_EMPLOYEES_FAILED](state, payload) {
    state.type = managerTypes.DELETE_EMPLOYEES_FAILED;
    state.error = payload.error;
  },
  [managerTypes.DELETE_EMPLOYEES_REQUEST](state) {
    state.type = managerTypes.DELETE_EMPLOYEES_REQUEST;
  }
};
